import { atomWithStorage } from "jotai/utils";

import { createCrossTabStorage } from "../store.utils";

export const currentAccountIdAtom = atomWithStorage<string>(
  "accountId",
  "",
  createCrossTabStorage<string>()
);
